<template>
  <div class="app-container">
    <h3 class="centre">Payment {{ result }}, redirecting to order detail...</h3>
  </div>
</template>

<script>
export default {
  data() {
    return {
      result: ""
    };
  },
  created() {
    const { result, orderId } = this.$route.query;
    this.result = result;
    if (orderId) {
      setTimeout(() => this.$router.push(`/order/${orderId}?isFromPaymentResult=true`), 3000);
    }
  },
  methods: {}
};
</script>

<style scoped lang="scss">
</style>